import React from 'react';
import { CardFormatType, CardSizeType, CollectionCardType } from '../../../../../types/decks';
import { CollectionCardLandscape } from './CollectionCardLandscape';
import { CollectionCardMiniHero } from './CollectionCardMiniHero';

export type CardProps = {
  card: CollectionCardType;
  cardSize: CardSizeType;
  cardFormat: CardFormatType;
};

export function CollectionCard(props: CardProps): React.ReactNode {
  switch (props.cardFormat) {
    case 'MINI_HERO':
      return <CollectionCardMiniHero {...props} />;
    case 'PORTRAIT':
    case 'LANDSCAPE':
      return <CollectionCardLandscape {...props} />;
    default: {
      const _exhaustive: never = props.cardFormat;
      void _exhaustive;
      return <CollectionCardLandscape {...props} />;
    }
  }
}
